var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"box13"},[_c('div',{staticClass:"left-box"},[_c('div',{staticClass:"left-btn",on:{"click":function($event){return _vm.zixun('免费领取')}}},[_vm._v("免费领取")])])])}
var staticRenderFns = []

export { render, staticRenderFns }